import { Component } from '@angular/core';

import {
  CamChartBarComponent,
  CamChartDoughnutComponent,
  CamChartLineComponent,
  CamChartMixedComponent,
  CamChartPieComponent,
} from '@camelot/charts';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        CamChartBarComponent,
        CamChartDoughnutComponent,
        CamChartLineComponent,
        CamChartMixedComponent,
        CamChartPieComponent,
        TestIdDirective,
    ],
    template: `
    <cam-bar-chart camTestId="cam-bar-chart" [labels]="this.labels" [datasets]="this.barDatasets" />
    <cam-line-chart camTestId="cam-line-chart" [labels]="this.labels" [datasets]="this.lineDatasets" />
    <cam-doughnut-chart camTestId="cam-doughnut-chart" [labels]="this.labels" [datasets]="this.barDatasets" />
    <cam-pie-chart camTestId="cam-pie-chart" [labels]="this.labels" [datasets]="this.barDatasets" />
    <cam-mixed-chart camTestId="cam-mixed-chart" [labels]="this.labels" [datasets]="this.mixedDatasets" />
  `
})
export class ChartsCase {
  public barDatasets = [{ data: [3, 5, 8], label: 'Series A' }];
  public labels = ['Jan', 'Feb', 'Mar'];
  public lineDatasets = [{ data: [1, 4, 2], label: 'Series B' }];
  public mixedDatasets = [
    { data: [3, 5, 8], label: 'Bars', type: 'bar' as const },
    { data: [1, 4, 2], label: 'Line', type: 'line' as const },
  ];
}
